/* =====================================================
   CART UPSELL — upgrade swap with animation
   ===================================================== */
(function () {
  'use strict';

  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');

  function getBanner() {
    return document.getElementById('cu-banner');
  }

  /* ── Event delegation — survives cart drawer re-renders ── */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cu-no]')) {
      const banner = getBanner();
      if (!banner) return;
      banner.classList.add('cu-banner--dismissed');
      setTimeout(() => banner.remove(), 300);
    }

    const yesBtn = e.target.closest('[data-cu-yes]');
    if (yesBtn && !yesBtn.disabled) {
      doUpgrade(yesBtn);
    }
  });

  /* ── Upgrade flow ── */

  async function doUpgrade(btn) {
    const banner = getBanner();
    if (!banner) return;

    const sourceVariantId  = parseInt(banner.dataset.sourceVariant, 10);
    const upgradeVariantId = parseInt(banner.dataset.upgradeVariant, 10);
    const lineIndex        = parseInt(banner.dataset.lineIndex, 10);

    /* UI: loading state */
    btn.disabled = true;
    const label   = btn.querySelector('.cu-btn__label');
    const spinner = btn.querySelector('.cu-btn__spinner');
    if (label)   label.textContent = 'Upgrading…';
    if (spinner) spinner.hidden = false;

    /* Animate the original cart row */
    const row = document.getElementById('CartDrawer-Item-' + lineIndex);
    if (row) row.classList.add('cu-item--upgrading');

    await pause(580);

    try {
      /* 1. Remove original variant by line position (more reliable than id lookup) */
      const changeRes = await fetch(root + '/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ line: lineIndex, quantity: 0 }),
      });
      if (!changeRes.ok) throw new Error('change failed');

      /* 2. Add upgrade variant — include sections for Dawn's renderContents */
      const cartDrawer = document.querySelector('cart-drawer');
      const sections   = cartDrawer
        ? cartDrawer.getSectionsToRender().map((s) => s.id)
        : [];

      const res = await fetch(root + '/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body:    JSON.stringify({
          id:           upgradeVariantId,
          quantity:     1,
          sections:     sections,
          sections_url: window.location.pathname,
        }),
      });

      if (!res.ok) throw new Error('add failed');
      const data = await res.json();

      /* 3. Re-render the drawer */
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
        /* 4. Highlight the new item after the DOM settles */
        setTimeout(() => highlightNewItem(upgradeVariantId), 420);
      }
    } catch (err) {
      console.error('[cart-upsell]', err);
      btn.disabled = false;
      if (label)   label.textContent = 'Upgrade ✦';
      if (spinner) spinner.hidden = true;
    }
  }

  /* ── Green glow on the newly added row ── */

  function highlightNewItem(variantId) {
    document
      .querySelectorAll('[data-quantity-variant-id="' + variantId + '"]')
      .forEach(function (input) {
        const row = input.closest('tr');
        if (!row) return;
        row.classList.add('cu-item--upgraded');
        setTimeout(() => row.classList.remove('cu-item--upgraded'), 2500);
      });
  }

  function pause(ms) {
    return new Promise((r) => setTimeout(r, ms));
  }
})();
